import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { Constant } from 'src/app/Common/constant';
import { LocalStorageService } from 'src/app/Model/Common/LocalStorageService';
import { APIFactoryEndPoints } from 'src/app/Model/Common/apifactory-end-points';
import { ErrorLog } from 'src/app/Model/Common/error-log';
import { ShippingFareSummaryDTO } from 'src/app/Model/Reports/shipping-fare-summary-dto';
import { ToastrService } from 'src/app/Service/Common/toastr.service';
import { RiderService } from 'src/app/Service/Rider/rider.service';
import { ShippingManagerService } from 'src/app/Service/Shipping/shipping-manager.service';
import { DatePipe } from '@angular/common';
import { ShippingFareShippingWise } from 'src/app/Model/Shipping/shipping-fare-shipping-wise';
import { RaiseDisputeOnShippingDto } from 'src/app/Model/Shipping/raise-dispute-on-shipping-dto';

@Component({
  selector: 'app-rider-orders',
  templateUrl: './rider-orders.component.html',
  styleUrls: ['./rider-orders.component.css']
})
export class RiderOrdersComponent implements OnInit {

  riderEmail: string;
  displayedColumns: string[] = ['date', 'shippingNo', 'tripNo', 'amount'];
  dataSource: MatTableDataSource<ShippingFareSummaryDTO>;
  summaryData: ShippingFareSummaryDTO[] = [];
  createSetUpForm: UntypedFormGroup;
  currDate = new Date();
  sumAmount: number = 0;
  sumQty: number = 0;

  errorLog: ErrorLog = new ErrorLog();

  // *******************************
  currentDiv = 'Daily';
  selectedValue: string;
  // totalQty: number = 0;
  // totalAmount: number = 0;
  // timeSpent: number = 0;
  filterData: string[] = [];

  filteredData: any[] = [];

  calculateTrip: any[] = [];

  toDate: string;
  fromDate: string;
  firstDayOfWeek: string;

  dates: any = [];
  allOrder: any = [];

  shippingWiseData: any = [];

  //Subscription
  private getSummaryDataSubscription: Subscription;
  private insertErrorLogSubscription: Subscription;

  private getDeliveryDetailsByRiderSubscription: Subscription;
  private saveRaiseDisputeSubscription: Subscription;

  constructor(
    public persistenceService: LocalStorageService,
    private constant: Constant,
    private formBuilder: UntypedFormBuilder,
    private toastService: ToastrService,
    public createRiderService: RiderService,
    private apiUrl: APIFactoryEndPoints,
    private shippingManagerService: ShippingManagerService,

    public datePipe: DatePipe,
  ) {
    this.riderEmail = JSON.parse(this.persistenceService.get("google_email"));
    this.dataSource = new MatTableDataSource(this.summaryData);
  }

  ngOnInit(): void {
    this.onCreateSetUp();

    this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.fromDate = moment().add(0, 'M').startOf('month').format('YYYY-MM-DD');
    this.firstDayOfWeek = this.datePipe.transform(
      this.getFirstDayOfWeek(new Date()),
      'yyyy-MM-dd'
    );
    this.getAllOrder();
  }

  ngOnDestroy() {
    if (this.getSummaryDataSubscription !== undefined)
      this.getSummaryDataSubscription.unsubscribe();

    if (this.insertErrorLogSubscription !== undefined)
      this.insertErrorLogSubscription.unsubscribe();
  }

  onCreateSetUp() {
    this.createSetUpForm = this.formBuilder.group({
      fromDate: [new Date(), Validators.required],
      toDate: [new Date(), Validators.required]
    })
  }

  // onViewClick() {
  //   if (this.createSetUpForm.invalid) {
  //     this.toastService.showErrorToast(this.constant.invalidFormToast);
  //     return;
  //   }
  //   let momentFromDate = new Date(this.createSetUpForm.get('fromDate').value);
  //   let formattedFromDate = moment(momentFromDate).format("YYYY-MM-DD");

  //   let momentToDate = new Date(this.createSetUpForm.get('toDate').value);
  //   let formattedToDate = moment(momentToDate).format("YYYY-MM-DD");

  //   this.getSummaryDataSubscription = this.shippingManagerService.getShippingSummaryData(this.apiUrl.getTripFareSummaryByRiderOnDate, this.riderEmail).subscribe((data) => {
  //     console.log(data)
  //     if (data.length > 0) {
  //       this.dataSource.data = data;
  //       this.sumAmount = 0;
  //       this.sumQty = 0;
  //       this.dataSource.data.forEach(element => {
  //         this.sumAmount = Number((this.sumAmount + element.amount).toFixed(2));
  //         // this.sumQty = this.sumQty + Number(element.tripNo);
  //         this.sumQty = data.length;
  //       })
  //     }
  //     else {
  //       this.toastService.showErrorToast(this.constant.noDataAvailableToast);
  //     }
  //   },
  //     (error: HttpErrorResponse) => {
  //       this.insertErrorLog("onViewClick", error);
  //     });
  // }

  insertErrorLog(errorMethod: string, error: HttpErrorResponse) {
    // this.errorLog.userId = this.persistenceService.get('userId');
    // this.errorLog.dateAndTime = moment(new Date()).format(this.constant.dateTimeFormatForDBServer);
    // this.errorLog.moduleName = "Shipping Date Wise Report";
    // this.errorLog.errorMethod = errorMethod;
    // this.errorLog.platform = "Web";
    // if (error?.error?.message || error?.error?.message != '')
    //   this.errorLog.errorDetails = error.error.message;
    // else
    //   this.errorLog.errorDetails = error.message;

    // this.insertErrorLogSubscription = this.containerService.insertErrorLog(this.apiUrl.insertErrorLog, this.errorLog).subscribe((data: any) => {
    // });
  }

  // **************NEW******************

  getAllOrder() {
    // this.divClick('Daily', this.toDate, this.toDate);
    // this.filterData.push(this.toDate + ' (Today)');
    this.getSummaryDataSubscription = this.shippingManagerService.getShippingSummaryData(this.apiUrl.getTripFareSummaryByRiderOnDate, this.riderEmail).subscribe((data) => {
      this.allOrder = data;
      this.divClick('Daily', this.toDate, this.toDate);
      if (data.length > 0) {
        this.dataSource.data = data;
        // this.sumAmount = 0;
        // this.sumQty = 0;
        // this.dataSource.data.forEach(element => {
        //   this.sumAmount = Number((this.sumAmount + element.amount).toFixed(2));
        //   // this.sumQty = this.sumQty + Number(element.tripNo);
        //   this.sumQty = data.length;
        // })
      }
      else {
        this.toastService.showErrorToast(this.constant.noDataAvailableToast);
      }
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("onViewClick", error);
      });
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  getFirstDayOfWeek(date: Date): Date {
    const day = date.getDay();
    const firstDay = new Date(date);
    firstDay.setDate(date.getDate() - day);
    return firstDay;
  }

  calculateDaysDiff(dateSent) {
    let currentDate = new Date();
    dateSent = new Date(dateSent);

    return Math.floor(
      (Date.UTC(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate()
      ) -
        Date.UTC(
          dateSent.getFullYear(),
          dateSent.getMonth(),
          dateSent.getDate()
        )) /
      (1000 * 60 * 60 * 24)
    );
  }

  divClick(divC: string, fromDate: string, toDate: string) {
    this.currentDiv = divC;
    if (divC == 'Daily') {
      document.getElementById('totEarning').innerText =
        'Total earnings for the day';
      document.getElementById('totTrip').innerText =
        'Total Trip for the day';
      document.getElementById('performanceHead').innerText =
        'Date wise performance';

      this.showBarChart(divC, fromDate, toDate);

      this.selectedValue = this.filterData[0];
    }
    if (divC == 'Weekly') {
      document.getElementById('totEarning').innerText =
        'Total earnings in the week';
      document.getElementById('totTrip').innerText =
        'Total Trip for the week';
      document.getElementById('performanceHead').innerText =
        'Week wise performance';

      this.filterData = [];
      let frD = moment().add(-2, 'M').startOf('month').format('YYYY-MM-DD');
      let frDt;
      let toDt;
      let k = 0;
      for (let i = 0; i < this.calculateDaysDiff(frD); i += 7) {
        frDt = moment().add(-i, 'd').startOf('week').format('YYYY-MM-DD');
        if (frDt < frD) frDt = frD;
        toDt = moment().add(-i, 'd').endOf('week').format('YYYY-MM-DD');
        if (toDt >= this.toDate) toDt = this.toDate + ' (This Week)';
        else {
          toDt = toDt + ' (Before ' + ++k + ' Week)';
        }

        this.filterData.push(frDt + ' to ' + toDt);
      }
      this.showBarChart(
        divC,
        this.filterData[0].split(' to ')[0],
        this.filterData[0].split(' to ')[1].split('(')[0]
      );
      this.selectedValue = this.filterData[0];
    }
    if (divC == 'Monthly') {
      document.getElementById('totEarning').innerText =
        'Total earnings for the month';
      document.getElementById('totTrip').innerText =
        'Total Trip for the month';
      document.getElementById('performanceHead').innerText =
        'Month wise performance';

      this.filterData = [];
      let frDate = moment().add(-2, 'M').startOf('month').format('YYYY-MM-DD');
      let allDate = this.getDates(
        new Date(this.datePipe.transform(frDate, 'yyyy-MM-dd')),
        new Date(this.datePipe.transform(this.toDate, 'yyyy-MM-dd'))
      );
      let trD;
      for (let i = 0; i <= 2; i++) {
        let frD = moment().add(-i, 'M').startOf('month').format('YYYY-MM-DD');
        trD = moment().add(-i, 'M').endOf('month').format('YYYY-MM-DD');
        if (i == 0) trD = this.toDate + ' (This Month)';
        if (i == 1) trD = trD + ' (In ' + this.getMonthNameFromMonthNo(Number(trD.split("-")[1])) + ')';
        if (i == 2) trD = trD + ' (In ' + this.getMonthNameFromMonthNo(Number(trD.split("-")[1])) + ')';

        this.filterData.push(frD + ' to ' + trD);
      }
      this.showBarChart(
        divC,
        this.filterData[0].split(' to ')[0],
        this.filterData[0].split(' to ')[1].split('(')[0]
      );
      this.selectedValue = this.filterData[0];
    }
  }

  getDates(startDate: Date, endDate: Date): Date[] {
    let currentDate: Date = startDate;
    this.dates = [];
    while (currentDate <= endDate) {
      this.dates.push(currentDate);
      currentDate = this.addDays(currentDate);
    }
    return this.dates;
  }
  private addDays(currentDate: Date): Date {
    let date = new Date(currentDate);
    date.setDate(date.getDate() + 1);
    return date;
  }

  getMonthNameFromMonthNo(no: number) {
    if (no == 1)
      return 'January'
    if (no == 2)
      return 'February'
    if (no == 3)
      return 'March'
    if (no == 4)
      return 'April'
    if (no == 5)
      return 'May'
    if (no == 6)
      return 'June'
    if (no == 7)
      return 'July'
    if (no == 8)
      return 'August'
    if (no == 9)
      return 'September'
    if (no == 10)
      return 'October'
    if (no == 11)
      return 'November'
    if (no == 12)
      return 'December'
  }

  onFilterSelect(data: any) {
    if (this.currentDiv == 'Daily') {
      this.showBarChart(
        this.currentDiv,
        data.split(' ')[0],
        data.split(' ')[0]
      );
    }
    if (this.currentDiv == 'Weekly' || this.currentDiv == 'Monthly') {
      this.showBarChart(
        this.currentDiv,
        data.split(' to ')[0],
        data.split(' to ')[1].split('(')[0]
      );
    }
  }

  showBarChart(source: string, fromDate: string, toDate: string) {
    const aggregateRecords = (data) => {
      const aggregated = {};
      data.forEach(item => {
        const key = `${item.onDate}_${item.tripNo}`;
        if (!aggregated[key]) {
          aggregated[key] = {
            onDate: item.onDate,
            tripNo: item.tripNo,
            amount: 0,
            servicemanAmount: item.servicemanAmount
          };
        }
        aggregated[key].amount += item.amount;
      });
      return Object.values(aggregated);
    };

    if (source == 'Daily') {
      this.filterData = [];
      this.filterData.push(this.toDate + ' (Today)');
      let frDate = moment().add(-2, 'M').startOf('month').format('YYYY-MM-DD');
      let allDates = this.getDates(
        new Date(this.datePipe.transform(frDate, 'yyyy-MM-dd')),
        new Date(this.datePipe.transform(this.toDate, 'yyyy-MM-dd'))
      );
      let k = 0;
      for (let i = allDates.length - 2; i >= 0; i--) {
        this.filterData.push(
          this.datePipe.transform(allDates[i].toString(), 'yyyy-MM-dd') +
          ' (Before ' +
          ++k +
          ' day)'
        );
      }

      document.getElementById('daily').style.setProperty('color', 'white');
      document.getElementById('weekly').style.setProperty('color', 'black');
      document.getElementById('monthly').style.setProperty('color', 'black');

      this.sumAmount = 0;
      // this.sumQty = 0;

      if (allDates.length > 0) {
        // let startDate = this.datePipe.transform(allDates[0], 'yyyy-MM-dd');
        // let endDate = this.datePipe.transform(allDates[allDates.length - 1], 'yyyy-MM-dd');


        this.filteredData = filterDataByDateRange(this.allOrder, fromDate, toDate);
        this.calculateTrip = aggregateRecords(this.filteredData);
        console.log(this.calculateTrip.length);
        // this.sumQty = this.filteredData.length;
        this.filteredData.forEach(element => {
          this.sumAmount = Number((this.sumAmount + element.amount).toFixed(2));
        })
      }
    }

    if (source == 'Weekly') {
      document.getElementById('daily').style.setProperty('color', 'black');
      document.getElementById('weekly').style.setProperty('color', 'white');
      document.getElementById('monthly').style.setProperty('color', 'black');

      this.sumAmount = 0;
      // this.sumQty = 0;
      let allDates = this.getDates(
        new Date(this.datePipe.transform(fromDate, 'yyyy-MM-dd')),
        new Date(this.datePipe.transform(toDate, 'yyyy-MM-dd'))
      );

      if (allDates.length > 0) {
        // let startDate = this.datePipe.transform(allDates[0], 'yyyy-MM-dd');

        // let endDate = this.datePipe.transform(allDates[allDates.length - 1], 'yyyy-MM-dd');

        this.filteredData = filterDataByDateRange(this.allOrder, fromDate, toDate);
        // this.sumQty = this.filteredData.length;
        this.calculateTrip = aggregateRecords(this.filteredData);
        console.log(this.calculateTrip.length);
        this.filteredData.forEach(element => {
          this.sumAmount = Number((this.sumAmount + element.amount).toFixed(2));
        })

      }
    }

    function filterDataByDateRange(data, startDate, endDate) {
      return data.filter(item => {
        return item.onDate >= startDate && item.onDate <= endDate;
      });
    }
    if (source == 'Monthly') {
      document.getElementById('daily').style.setProperty('color', 'black');
      document.getElementById('weekly').style.setProperty('color', 'black');
      document.getElementById('monthly').style.setProperty('color', 'white');

      let allDates = this.getDates(
        new Date(this.datePipe.transform(fromDate, 'yyyy-MM-dd')),
        new Date(this.datePipe.transform(toDate, 'yyyy-MM-dd'))
      );

      this.sumAmount = 0;
      // this.sumQty = 0;
      if (allDates.length > 0) {
        // let startDate = this.datePipe.transform(allDates[0], 'yyyy-MM-dd');

        // let endDate = this.datePipe.transform(allDates[allDates.length - 1], 'yyyy-MM-dd');

        this.filteredData = filterDataByDateRange(this.allOrder, fromDate, toDate);
        // this.sumQty = this.filteredData.length;
        this.calculateTrip = aggregateRecords(this.filteredData);
        console.log(this.calculateTrip.length);
        this.filteredData.forEach(element => {
          this.sumAmount = Number((this.sumAmount + element.amount).toFixed(2));
        })

      }
    }
  }

  toggleDetails(onDate: string, shippingNo: string, tripNo: string) {
    const item = this.filteredData.find(item => item.shippingNo === shippingNo && item.tripNo === tripNo && item.onDate === onDate);
    if (item) {
      item.showDetails = !item.showDetails;

      if (item.showDetails) {
        let momentDate = new Date(this.createSetUpForm.get('fromDate').value);
        let formattedFromDate = moment(momentDate).format("YYYY-MM-DD");

        this.getDeliveryDetailsByRiderSubscription = this.shippingManagerService.getDeliveryFareDetailsByRider(this.apiUrl.getDeliveryFareDetailsByRiderEmailIdAndDateRange, this.riderEmail, item.onDate, tripNo, shippingNo).subscribe((data) => {
          if (data.length > 0) {
            item.shippingFareShippingWise = data;
            this.shippingWiseData = item.shippingFareShippingWise
          }
          else {
            this.toastService.showErrorToast(this.constant.noDataAvailableToast);
          }
        });
      }
    }
  }
  onSaveRaiseDisputeClick(shippingFareShippingWise: ShippingFareShippingWise) {
    console.log(this.shippingWiseData);
    let dispute: RaiseDisputeOnShippingDto = new RaiseDisputeOnShippingDto();
    dispute.onDateTime = moment(new Date()).format("yyyy-MM-DD HH:mm:ss");
    dispute.shippingNo = this.shippingWiseData[0].usedForRefNo;
    dispute.currentStatus = "Dispute";
    dispute.reason = "NA";
    dispute.finalAmount = 0;
    dispute.additionalAmountIfAny = 0;
    dispute.serviceManID = this.shippingWiseData[0].serviceManID;
    dispute.amountAsPerSuggestedRoute = this.shippingWiseData[0].netAmount;

    this.saveRaiseDisputeSubscription = this.shippingManagerService.saveRaiseDispute(this.apiUrl.insertRaiseDispute, dispute).subscribe((data) => {
      if (data) {
        this.toastService.showSuccessToast(this.constant.requestraiseToast)
      }
    });
    // this.onViewClick();
  }

}
